import { render, staticRenderFns } from "./CommonInputs.vue?vue&type=template&id=706fb440"
import script from "./CommonInputs.vue?vue&type=script&lang=js"
export * from "./CommonInputs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports